import helper from "@/config/helper";
import Vue from "vue";

const toastrOptions = {
	position: "top",
};

const state = {
	query:				"",
	list:				[],
	viewMode:			"grid",
	productsTotal:		0,
	productsPage:		0,
	selectedProduct:	{}
}

const actions = {
	getAvailableProducts({ commit, state, rootGetters, rootState }){
		commit("setLoading", true, { root: true });

		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("search",			state.query);
		data.append("page",				state.productsPage);
		data.append("method",			"getAvailableProducts");
		data.append("merchant_number",	rootState.subscriptionDetail.merchant_number);
		data.append("subscription_id",	rootState.subscriptionDetail.subscription_id);

		helper
			.axios()
			.post("", data)
			.then((response) => {
				const data = response.data;

				const total = data.total;
				const products = data.products.map((product) => {
					product.quantity = 0;
					product.show = true;
					return product;
				});

				commit("updateTotal", total);
				commit("updateProducts", products);
			})
			.catch((error) => {
				helper.callback_error(error);
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	},

	addNewProduct({ commit, dispatch, state, rootGetters, rootState }){
		commit("setLoading", true, { root: true });

		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("method",			"addNewProduct");
		data.append("product",			JSON.stringify(state.selectedProduct));
		data.append("merchant_number",	rootState.subscriptionDetail.merchant_number);
		data.append("subscription",		rootState.subscriptionDetail.order_number);

		helper
			.axios()
			.post("", data)
			.then(() => {
				dispatch("getAvailableProducts");
				dispatch("subscriptionDetail/getCurrentProducts", null, { root: true });
				dispatch("analytics/setFeedback", "add_product", { root: true });
				commit("resetQuery");
				commit("resetPage");
				commit("modals/setDialogAddProduct", false, { root: true });
				Vue.$toast.success("Produto adicionado com sucesso.", toastrOptions);
			})
			.catch((error) => {
				helper.callback_error(error);
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	}
}

const mutations = {
	setGridViewMode(state){
		state.viewMode = "grid";
	},

	setColumnViewMode(state){
		state.viewMode = "column";
	},

	resetPage(state){
		state.productsPage = 0;
	},

	nextPage(state){
		state.productsPage++;
	},

	previousPage(state){
		state.productsPage--;
	},

	selectProduct(state, content){
		if(content.on_customer_area){
			content.additionOption = 'subscription';
		}else if(content.single_purchase){
			content.additionOption = 'single_purchase';
		}
		content.quantity = 1;
		state.selectedProduct = content;
	},

	resetSelectedProduct(state){
		state.selectedProduct = {};
	},

	changeAdditionOption(state, content){
		state.selectedProduct.additionOption = content;
	},

	incrementQuantity(state){
		state.selectedProduct.quantity++;
	},

	decrementQuantity(state){
		if(state.selectedProduct.quantity == 1) {
			return;
		}
		state.selectedProduct.quantity--;
	},

	updateTotal(state, content){
		state.productsTotal = content;
	},

	updateProducts(state, content){
		state.list = content;
	},

	resetQuery(state){
		state.query = "";
	},

	setQuery(state, content){
		state.query = content;
	}
}

const getters = {
	isGridSelected(state){
		return state.viewMode == 'grid';
	},
	
	isColumnSelected(){
		return state.viewMode == 'column';
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};